import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Card, CardBody } from "reactstrap";
import GeneralGrid from "../../Components/GeneralGrid";
import exceptionHandler from "../../_helpers/exceptionHandler";
import { api } from "../../_services/api.service";
import FieldSettingsModal from "./FieldSettingsModal";

const FieldsCard = ({
  milestones,
}) => {
  let [fields, setFields] = useState([]);
  let [selectedField, setSelectedField] = useState(undefined);
  let [isFieldModalOpen, setIsFieldModalOpen] = useState(false);
  let [milestoneTypes, setMilestoneTypes] = useState([]);
  const fieldColumns = [
    {
      dataField: "phaseText",
      text: "Phase",
      sort: false,
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "milestoneText",
      text: "Milestone",
      sort: false,
      headerStyle: () => {
        return { width: "30%" };
      },
    },
    {
      dataField: "fieldName",
      text: "Field",
      sort: false,
      headerStyle: () => {
        return { width: "30%" };
      },
      formatter: (cellContent, row) => {
        return (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            key={"x" + row.fieldID}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              goToField(row.fieldID);
            }}
          >
            {cellContent}
          </a>
        );
      },
    },
    {
      dataField: "fieldType",
      text: "Field Type",
      sort: false,
      headerStyle: () => {
        return { width: "20%" };
      },
    },
  ];

  useEffect(() => {
    let milestoneTypes = milestones && milestones.map(m => ({ id: m.milestoneID, name: m.milestoneText }));

    if (milestoneTypes) {
      milestoneTypes.push({ id: 0, name: "TBD" });
      setMilestoneTypes(milestoneTypes);
    }

    loadFields();
  }, [milestones]);

  const loadFields = () => {
    const milestoneIDs = milestones && milestones.map(x => x.milestoneID);
    if (milestoneIDs && milestoneIDs.length > 0) {
      api.getFieldsByMilestones(milestoneIDs)
        .then(data => {
          if (data) setFields(data);
        })
        .catch(exceptionHandler);
    }
  }

  const goToField = (fieldID) => {
    let field;
    if (fieldID === -1) { // user adding new field
      const maxOrderID = fields.length === 0 ? -1 : Math.max(...fields.map(p => p.orderID))
      field = {
        fieldID: -1,
        fieldName: "",
        orderID: maxOrderID + 1,
        milestoneID: 0,
        fieldType: "ShortText",
        fieldLabel: "",
        instructions: "",
        mandatory: false,
        points: 0,
        addAltObj: "NA",
        addQuestion: "",
        altObjName: "",
        fieldOptions: [],
      }
    } else {
      field = fields.find(p => p.fieldID === fieldID);
    }
    
    setSelectedField(field);
    toggleFieldModal();
  };

  const toggleFieldModal = () => {
    setIsFieldModalOpen(!isFieldModalOpen);
  }

  return  (
    <>
      <Card className="main-card mb-3">
        <CardBody>
          <GeneralGrid
            colWidth={12}
            title={"Fields"}
            keyField="fieldID"
            dataSource={fields}
            columns={fieldColumns}
            defaultSortedColumn="orderID"
            showAddButton={true}
            buttonText={"Add Field"}
            onAdd={() => {
              goToField(-1);
            }}
          />
        </CardBody>
      </Card>

      <FieldSettingsModal
        showModal={isFieldModalOpen}
        toggleModal={toggleFieldModal}
        fieldItem={selectedField}
        milestoneTypes={milestoneTypes}
        reloadList={loadFields}
      />
    </>
  )
};

export default FieldsCard;